const _ = require('lodash')

const common = {
  menu: 'Meny',
  currentProduct: {
    id: '39037',
    url:
      '/se/sv/utrustning/tillbehor/belysning/arbetsbelysning-led/arbetsbelysning-led/39037/',
    name: 'Arbetsbelysning  Alcor LED',
    description:
      'Arbetsstrålkastare Alcor, 5 x 3W LED, formgjutet aluminiumhus, IP67. Med högintensiva Cree-dioder. Bred ljusbild. Rostfritt fäste med M10 bult. Levereras med 50 cm kabel. E-märkt. Det uppmätta värdet är utfört hos SP (Sveriges Tekniska Forskningsinstitut).',
    information: null,
    specification: {
      Specifikation: {
        'Antal dioder': '5 ',
        'Effekt per diod': '3 W',
        Effektförbrukning: '14,5 W',
        'Ljusflöde teoretiskt värde': '1200 lm',
        'Ljusflöde uppmätt värde': '735 lm',
        Spänning: '9-32 V'
      },
      Mått: { Bredd: '110 mm', Djup: '40 mm', Höjd: '110 mm' }
    },
    items: [
      {
        id: '39037',
        specification: [],
        stock: 342,
        url:
          '/sv/utrustning/tillbehor/belysning/arbetsbelysning-led/arbetsbelysning-led/39037/',
        customerPrice: null,
        imageUrl: null,
        mediaAssetsUrl: [''],
        isOrderItem: false,
        sortOrder: 0
      }
    ],
    lowestPrice: null,
    imageUrl: '/globalassets/pim/39/39037_1.jpeg',
    mediaAssetsUrl: [
      '/globalassets/pim/39/39037_1.jpeg',
      '/globalassets/pim/39/39037_1_nr2.jpeg',
      '/globalassets/pim/39/39037_1.jpg',
      '/globalassets/pim/39/39037_1_nr2.jpg',
      '/globalassets/pim/39/39037_1_nr3.jpg',
      '/globalassets/pim/39/39037_lampa2.jpg',
      '/globalassets/pim/39/39037_ritning.jpg',
      '/globalassets/pim/39/39037_ljusbild.jpg',
      '/globalassets/pim/39/39037_3_Skog.JPG',
      '/globalassets/pim/39/39037_3_Vag.JPG'
    ],
    videoAssetUrl: null,
    section: 'Arbetsbelysning LED',
    newsSection: '',
    newsPriority: null,
    campaignSection: null,
    sectionType: 'info',
    contextDescription: '',
    currentVehicle: null
  },
  selectedModel: 'CVLVehicleModel%7CLastmaskinKOMATSUWA403',
  selectedCategory: '8e39bbc4d0fe45b1a5c4f94f975419e6',
  searchResultPageUrl: '/sök',
  cartType: 0,
  thresholdFewStock: 5,
  inEditMode: false,
  sharedId: 1000,
  cartId: 5178,
  productPageSize: 40,
  isRequiredInvoiceReferenceOrderNumber: true,
  isAuthenticated: true,
  cartPageUrl: '/cart',
  orderConfirmPageUrl: '/kassa',
  // uniqueId: 'D9FAF98D08ADE455930DD6578C5AA03D',
  // impersonating: {
  //   name: 'Linda testar',
  //   customerNumber: '156925',
  //   userName: 'order@oie.se',
  //   anonymous: false,
  //   superUserUserName: 'zoran.gavric@tietoyevry.com',
  //   superUserName: 'Zoran Gavric'
  // },
  // user: {
  //   name: 'Linda testar',
  //   customerNumber: '156925',
  //   userName: 'order@oie.se'
  // },
  impersonating: null,
  user: {
    name: 'Zoran Gavric',
    customerNumber: '156925',
    userName: 'order@oie.se'
  },
  apiBasePath: '/mvcapi/se/sv',
  currentMarket: 'se',
  currentLanguage: 'sv',
  currency: 'SEK',
  region: 'sv-SE',
  enableGtm: true,
  // currentVehicle: { itemId: 'CVLVehicleModel|TraktorFENDTFarmer106S', model: 'Fendt', displayName: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum, deleniti.', url: '/se/sv/Fordon/Traktor/FENDT/Farmer-106/' },
  currnetVehicle: {
    itemId: 'CVLVehicleModel|TraktorJOHNDEERE1630',
    brand: 'JOHN DEERE',
    displayName: '1630',
    url: '/se/sv/fordon/traktor/john-deere/1630/'
  },
  // currentVehicle: null,
  // countryList: [{ 'text': 'Sverige', 'value': 'SE', 'isDefault': true, 'postalCodeMask': '### ##', callingCode: '+46' }],
  countryList: [
    {
      text: 'Sverige',
      value: 'SE',
      isDefault: true,
      postalCodeMask: '### ##',
      postalCodeRule: '\\d{3}[ ]?\\d{2}$',
      callingCode: '+46'
    }
  ],
  // countryList: [{ 'text': 'Norge', 'value': 'NO', 'isDefault': true, 'postalCodeMask': '####' }],
  // countryList: [
  //   { 'text': 'Finland', 'value': 'FI', 'isDefault': false, 'postalCodeMask': '### ##' },
  //   { 'text': 'Åland', 'value': 'AX', 'isDefault': true, 'postalCodeMask': '###' }
  // ],
  // countryList: [
  //   {
  //     'text': 'Austria',
  //     'value': 'AT',
  //     'isDefault': true,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+43'
  //   },
  //   {
  //     'text': 'Belgium',
  //     'value': 'BE',
  //     'isDefault': false,
  //     'postalCodeMask': '####',
  //     'postalCodeRule': '',
  //     'callingCode': '+32'
  //   },
  //   {
  //     'text': 'Croatia',
  //     'value': 'HR',
  //     'isDefault': false,
  //     'postalCodeMask': '#####',
  //     'postalCodeRule': '',
  //     'callingCode': '+385'
  //   },
  //   {
  //     'text': 'Estonia',
  //     'value': 'EE',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+372'
  //   },
  //   {
  //     'text': 'France',
  //     'value': 'FR',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+33'
  //   },
  //   {
  //     'text': 'Germany',
  //     'value': 'DE',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+49'
  //   },
  //   {
  //     'text': 'Hungary',
  //     'value': 'HU',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+36'
  //   },
  //   {
  //     'text': 'Italy',
  //     'value': 'IT',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+39'
  //   },
  //   {
  //     'text': 'Latvia',
  //     'value': 'LV',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+371'
  //   },
  //   {
  //     'text': 'Lithuania',
  //     'value': 'LT',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+370'
  //   },
  //   {
  //     'text': 'Netherlands',
  //     'value': 'NL',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+31'
  //   },
  //   {
  //     'text': 'Poland',
  //     'value': 'PL',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+48'
  //   },
  //   {
  //     'text': 'Portugal',
  //     'value': 'PT',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+351'
  //   },
  //   {
  //     'text': 'Slovenia',
  //     'value': 'SI',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+386'
  //   },
  //   {
  //     'text': 'Spain',
  //     'value': 'ES',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+34'
  //   },
  //   {
  //     'text': 'United Kingdom',
  //     'value': 'GB',
  //     'isDefault': false,
  //     'postalCodeMask': '',
  //     'postalCodeRule': '',
  //     'callingCode': '+44'
  //   }
  // ],
  orderDetailsDescription:
    'Vi plockar och packar och skickar den så snart som möjligt. Har du några frågor? Kontakta oss på kundservice@olssonparts.com',
  validationRules: {
    required: { message: 'Fältet är obligatoriskt!' },
    invalidchars: { message: 'Fältet innehåller ogiltiga tecken!' },
    email: { message: 'E-post är inte korrekt!' },
    numeric: { message: 'Fältet får endast innehålla siffror!' },
    min: { message: 'Fältet innehåller för få tecken!' },
    max: { message: 'Fältet innehåller för många tecken!' },
    is: { message: 'Fältet får inte vara samma värde!' },
    is_not: { message: 'Fältet matchar inte det angivna värdet!' },
    confirmed: { message: 'Fältet matchar inte det angivna värdet!' },
    password: { message: 'Lösenorden matchar inte!' },
    passwordPolicy: {
      message:
        'Lösenordet måste innehålla minst 6 tecken. En stor och en liten bokstav samt en siffra.'
    },
    postalCode: { message: 'Felaktigt postnummer!' },
    checked: { message: null },
    vatNumber: { message: null }
  },
  // vehicleFilterFractions: [
  //   {
  //     'fractionId': 'Motorbeteckning',
  //     'fractionTypes': [
  //       {
  //         'groupId': 0,
  //         'name': 'D42 (med 42 mm kolvbult)',
  //         'icon': '',
  //         'modelCode': 'CVLVehicleModel|TraktorVOLVOBMBM650',
  //         'modelName': 'VOLVO BM / T650',
  //         'description': 'Motorbeteckning: D42 (med 42 mm kolvbult)',
  //         'items': [
  //           'BM-11030066',
  //           '93173960',
  //           'MS8',
  //           '44437',
  //           '54234',
  //           '64500'
  //         ]
  //       },
  //       {
  //         'groupId': 0,
  //         'name': 'D42 (med 40 mm kolvbult)',
  //         'icon': '',
  //         'modelCode': 'CVLVehicleModel|TraktorVOLVOBMBM650',
  //         'modelName': 'VOLVO BM / T650',
  //         'description': 'Motorbeteckning: D42 (med 40 mm kolvbult)',
  //         'items': [
  //           'BM-780365',
  //           'MS7',
  //           '43970',
  //           '52585'
  //         ]
  //       },
  //       {
  //         'groupId': 0,
  //         'name': 'D42 (med 40 mm kolvbult)',
  //         'icon': '',
  //         'modelCode': 'CVLVehicleModel|TraktorVOLVOBMBM650',
  //         'modelName': 'VOLVO BM / T650',
  //         'description': 'Motorbeteckning: D42 (med 40 mm kolvbult)',
  //         'items': [
  //           'BM-780365',
  //           'MS7',
  //           '43970',
  //           '52585'
  //         ]
  //       },
  //       {
  //         'groupId': 0,
  //         'name': 'D42 (med 42 mm kolvbult)',
  //         'icon': '',
  //         'modelCode': 'CVLVehicleModel|TraktorVOLVOBMBM650',
  //         'modelName': 'VOLVO BM / T650',
  //         'description': 'Motorbeteckning: D42 (med 42 mm kolvbult)',
  //         'items': [
  //           'BM-11030066',
  //           '93173960',
  //           'MS8',
  //           '44437',
  //           '54234'
  //         ]
  //       }
  //     ],
  //     'name': null
  //   },
  //   {
  //     'fractionId': 'Motornummer',
  //     'fractionTypes': [
  //       {
  //         'groupId': 0,
  //         'name': '29766-',
  //         'icon': '',
  //         'modelCode': 'CVLVehicleModel|TraktorVOLVOBMBM650',
  //         'modelName': 'VOLVO BM / T650',
  //         'description': 'Motornummer: 29766-',
  //         'items': [
  //           'BM-11030066',
  //           '93173960',
  //           'MS8',
  //           '44437',
  //           '54234',
  //           '64500'
  //         ]
  //       },
  //       {
  //         'groupId': 0,
  //         'name': '-29765',
  //         'icon': '',
  //         'modelCode': 'CVLVehicleModel|TraktorVOLVOBMBM650',
  //         'modelName': 'VOLVO BM / T650',
  //         'description': 'Motornummer: -29765',
  //         'items': [
  //           'BM-780365',
  //           'MS7',
  //           '43970',
  //           '52585'
  //         ]
  //       }
  //     ],
  //     'name': null
  //   }
  // ],
  blocks: {
    1000: {
      showMatchingArticles: 'Visa matchande artiklar: {0}',
      stockAvailableLabel: 'Finns i lager',
      stockFewLabel: 'Fåtal i lager',
      stockNoneLabel: 'Tillfälligt slut',
      stockNoneBackorderDateItemLabel:
        'Tillfälligt slut. Beräknas åter i lager {0}',
      stockNoneEstimatedItemLabel: 'Tillfälligt slut. Beräknad leveranstid {0}',
      stockIsOrderItemLabel: 'Beställningsvara',
      stockNoneOrderItemLabel: 'Beställningsvara. Skickas tidigast {0}',
      listPriceLabel: 'Listpris',
      tableHeaderVariantArtNo: 'Artikelnummer',
      tableHeaderVariantStock: 'Lagerstatus',
      tableHeaderVariantPrice: 'Pris',
      tableHeaderVariantQuantity: 'Antal',
      tableRowVariantArtNo: 'Artnr:',
      headerRelatedArticles: 'Du kanske också behöver',
      measurementLink: null,
      bracketPriceText: 'Vid köp av {0} eller mer är styckpriset {1}.',
      titleFractionModel: 'Passar modell {0}',
      titleTechnicalFacts: 'Teknisk fakta',
      addToCartButtonLabel: 'Köp',
      headerCartHeader: 'Varukorg',
      headerCartHeaderItem: 'Artikel',
      headerCartHeaderQuantity: 'Antal',
      headerCartHeaderSendQuantityNow: 'Skickas nu',
      headerCartHeaderSendQuantityLater: 'Skickas senare',
      headerCartHeaderComment: 'Kommentar',
      headerCartHeaderPrice: 'Pris',
      headerCartPin: 'Fäst',
      headerCartUnpin: 'Lossa',
      cartGotoCheckout: 'Gå till kassan',
      goToLargeCart: 'Gå till varukorgen',
      headerCartQuickAddPlaceholder: 'Lägg till via artikelnummer',
      headerCartItemNumberLabel: 'Art.nr.',
      headerCartItemsCostLabel: 'Varukostnad',
      headerCartEmptyHeader: 'Varukorgen är tom!',
      headerCartEmptyText:
        'Börja handla på sajten eller skriv in artikelnummer direkt i fältet ovan.',
      mergeCartHeader: 'Din varukorg',
      mergeCartText:
        'Du har en sparad varukorg sedan tidigare. Vill du slå ihop den med din nuvarande varukorg?',
      mergeCartYesMergeCarts: 'Ja, slå ihop mina varukorgar',
      mergeCartDontUseSavedCart: 'Nej, ersätt min sparade varukorg',
      mergeCartUseSavedCart: 'Avbryt, använd sparad varukorg',
      showPricesWithVat: 'Inkl. moms',
      showPricesWithoutVat: 'Exkl.moms',
      vatLabel: 'Moms',
      onText: 'På',
      offText: 'Av',
      headerCartItemsVatLabel: 'Momskostnad',
      headerCartItemAmountLabel: 'st',
      headerCartNoteDeleteLabel: 'Radera',
      headerCartNotePlaceholder: 'Skriv en egen kommentar',
      headerCartNoteSaveLabel: 'Spara',
      headerCartNoteCloseLabel: 'Stäng',
      exceededStockLevelLabel: 'OBS Fler än i lager',
      cartClearSelectedArticles: 'Ta bort',
      cartCreateList: 'Skapa inköpslista',
      cartAddToCurrentList: 'Lägg till inköpslista',
      cartSummaryTotal: 'Total',
      mySavedLists: 'Mina inköpslistor',
      newShoppingList: 'Ny inköpslista',
      newShoppingListLabel: 'Döp din inköpslista',
      newShoppingListButtonCreate: 'Skapa',
      cartUpdateCurrentList: 'Spara inköpslista',
      cartAddToCart: 'Lägg till i varukorgen',
      addToExistingList: 'Lägg till inköpslista',
      cartSumHeaderLabel: 'Summering av varukorg',
      cartProductHeaderLabel: 'Artikelnamn',
      cartStatusSendNowLabel: 'Kan skickas nu',
      cartStatusSendLaterLabel: 'Skickas senare',
      cartQuantityLabel: 'Antal',
      cartRowCommentLabel: 'Kommentar för egen del',
      cartRowPriceLabel: 'Pris per styck',
      paymentMethodsLabel: 'Betalsätt',
      cartRowPriceTotalLabel: 'Totalt',
      superUserPurchasePrice: 'Inköpspris',
      superUserShippingCurrentlyLabel: 'Nuvarande pris:',
      superUserShippingCurrencyLabel: 'Kr:',
      superUserShippingLabel: 'Frakt',
      superUserCartTotalTb: 'TB',
      superUserCartTotalTg: 'TG',
      superUserShippingPercentageLabel: 'Procent:',
      idNumberPlaceholderText: 'Ange org.nr/pers.nr ÅÅMMDDNNNN',
      idNumberLabel: 'Organisationsnummer/Personnummer (ÅÅMMDDNNNN)*',
      checkoutInvoiceRequirementTitleLabel:
        'Tryck här för att läsa vilka krav vi har för att vara en fakturakund',
      checkoutInvoiceRequirementText:
        'För att ansöka som fakturakund är minimikravet redovisad inkomst på minst 100 000 kr och inga betalningsanmärkningar.  För att godkännas som fakturakund måste din uppgivna leverans- och fakturaadress vara samma som din folkbokföringsadress/adress på bolagsverket.  Kreditupplysning kommer att tas, om den inte går igenom kontaktas du via mejl och din order annulleras.',
      pdfInvoiceLabel: 'PDF-faktura',
      pdfEmailInvoiceLabel: 'E-post för PDF-faktura*',
      pdfEmailInvoicePlaceholder: 'Ange e-post för PDF-faktura',
      failedToGetPricesWarning:
        'Just nu kan vi inte hämta dina rabatterade priser. Bara lugn, när din order kommer in till oss korrigerar vi till de rätta priserna.',
      customerNumberLabel: 'Kundnummer',
      orderCreatedLabel: 'Orderdatum',
      orderDeliveryTypeLabel: 'Leveranssätt',
      orderPaymentTypeLabel: 'Betalningssätt',
      orderPartDeliveryLabel: 'Dellevereras',
      orderPartDeliveryTypeTrue: 'Ja',
      orderPartDeliveryTypeFalse: 'Nej',
      orderCommentLabel: 'Orderkommentar',
      orderRowArticleNumber: 'Artikelnummer',
      orderRowQuantity: 'Antal',
      orderRowSendNowQuantity: 'Skickas nu',
      orderRowSendLaterQuantity: 'Skickas senare',
      orderRowCommentLabel: 'Kommentar',
      orderRowPriceLabel: 'Pris',
      compareProducts: 'Jämför',
      showMoreLink: 'Visa fler',
      closeLink: 'Stäng',
      openLink: 'Öppna',
      articleNumberLabel: 'Artikelnr:',
      titleVehicleChoose: null,
      chooseFavoriteVehicle: 'Välj',
      titleFavoriteVehicle: 'Favoriter',
      titleLatestVisits: 'Senast besök',
      titleAddMachine: 'Lägg till en ny maskin',
      titleEditFavorite: 'Ändra',
      titleCloseEditFavorite: 'Stäng',
      titleVehicleSelectorHeader: 'Reservdelar',
      descriptionVehicleSelector: null,
      titleVehicleSelectorChooseBrand: 'Välj tillverkare av',
      titleVehicleSelectorChooseModel: 'Välj modell av',
      titleVehicleSelectorExpandBrand: 'Alla fordonstyper',
      titleVehicleSelectorExpandModel: 'Alla modeller',
      titleVehicleSelectorCloseLink: 'Stäng',
      titleVehicleSelectorFilterSearchPlaceholder: 'Sök efter modell',
      titleVehicleSelectorFilterSearch: null,
      filterBarTitleShowArticle: 'Artikelutförande',
      filterBarTitleShowTechInfo: 'Teknisk information',
      filterBarTitleShowTaxInfo: null,
      filterBarDropDownTitleSortorder: 'Välj sortering',
      filterBarTitleCount: 'st artiklar',
      vehicleFilterFractionTitle: 'Filtrera på fordonsspecifikation',
      vehicleFilterFractionDescription:
        'För att underlätta val av rätt artikel kan här väljas brytning. Observera att det efter valet ändå kan finnas ytterligare brytningsinformation på enskilda artiklar. ',
      priceExcludingVat: 'exkl. moms',
      priceIncludingVat: 'inkl. moms',
      campaignPrice: 'Kampanjpris',
      fromPriceLabel: 'Från',
      fractionsAttentionText:
        '<strong>OBS!</strong> Produkten kräver ytterligare filterval för att kunna rekommenderas',
      contextDescriptionLabel: 'OBSERVERA:',
      showArticles: 'Visa artiklar',
      showLessArticles: 'Dölj artiklar',
      chooseMarketAndLanguageLabel: 'Välj land och språk',
      labelCountry: 'Land',
      labelLanguage: 'Språk',
      chooseMarketAndLanguageButtonLabel: 'Byt land och språk',
      signInIncorrectMarketHeader: 'Det verkar som att du är på fel marknad',
      signInIncorrectMarketDescription:
        'Ditt konto tillhör en annan marknad, klicka nedan för att komma vidare',
      signInIncorrectMarketContinue: 'Fortsätt till din marknad',
      switchMarketInfoDescription:
        'Du håller på att byta marknad, din varukorg kommer inte att flyttas med.',
      switchMarketContinueAction: 'Logga ut och fortsätt till vald marknad',
      signOutMenuItem: 'Logga ut',
      orderHistoryMenuItem: 'Orderhistorik',
      myAccountMenuItem: 'Mina sidor',
      myAddressesMenuItem: 'Mina adresser',
      myAccountMenuItemTitle: 'Mina sidor',
      email: 'E-post*',
      enlargeLink: 'Förstora',
      emailPlaceholder: 'Ange e-post',
      acceptCookies: 'Acceptera cookies',
      cookieConsentMarkup:
        '<p><br /><br />Olssons i Ell&ouml;s anv&auml;nder cookies.&nbsp;<a href="/link/733e7929549d4f9dbea8da92c5833f96.aspx" target="_blank" rel="noopener">L&auml;s mer</a><br /><br /><br /></p>',
      fullNamePlaceholder: 'Ange för- och efternamn',
      addressNameLabel: 'Namn*',
      addressNamePlaceholder: 'Ange namn',
      addressStreetLabel: 'Gatuadress*',
      addressStreetPlaceholder: 'Ange gatuadress',
      addressPostalLabel: 'Postnummer*',
      addressPostalPlaceholder: 'Ange postnummer',
      addressCityLabel: 'Ort*',
      addressCityPlaceholder: 'Ange ort',
      addressCountryLabel: 'Land',
      addressCountryPlaceholder: 'Välj land',
      errand: 'Ärende*',
      errandPlaceholder: 'Ange ärende',
      sendButton: 'Skicka',
      footerNewsletterHeader: 'Nyhetsbrev',
      footerNewsletterPlaceholder: 'Ange din e-post',
      footerNewsletterAnchor: 'newsletter',
      myPricesShowing: 'Mitt pris',
      listPriceShowing: 'Listpris',
      genericDelete: 'Ta bort',
      genericClose: null,
      genericSearch: 'Sök',
      genericSave: 'Spara',
      modalCancel: 'Avbryt',
      noResults: 'Tyvärr, vi hittade inget resultat!',
      searchAgain: 'Inga träffar, var god försök igen!',
      showAll: 'Visa alla',
      items: 'Artiklar',
      categories: 'Kategorier',
      models: 'Modeller',
      searchSitePlaceholder: 'Skriv sökord eller ref.nr. här',
      validateRequiredField: 'Fältet är obligatoriskt!',
      validateEmailField: 'E-post är inte korrekt!',
      validateNumericField: 'Fältet får endast innehålla siffror!',
      validateMinField: 'Fältet innehåller för få tecken!',
      validateMaxField: 'Fältet innehåller för många tecken!',
      validateIsNotField: 'Fältet matchar inte det angivna värdet!',
      validateIsField: 'Fältet får inte vara samma värde!',
      validatePasswordMatch: 'Lösenorden matchar inte!',
      validatePasswordPolicy:
        'Lösenordet måste innehålla minst 6 tecken. En stor och en liten bokstav samt en siffra.',
      validateChecked: null,
      validatePostalCode: 'Felaktigt postnummer!',
      validateVatNumber: null,
      searchResultDidYouMean: 'Menade du',
      cartArticlesInList: 'Produkter i listan:',
      quickOrderFileSuccessAmountText: '{0}st har lagts till i listan.',
      quickOrderFileOtherErrorText: 'Opps! {0} har inte lagts till i listan.',
      quickOrderFileFormatErrorText:
        'Opps! Vi har inte lagt till {0} pga formateringsfel i filen.',
      quickOrderUploadInstructionsUrl: 'https://filmstaden.se',
      rustyBrowserMessageBarText:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean m',
      vehicleHistoryVisited: 'Besökta fordon',
      vehicleHistoryRecentlyVisited: 'Senast besökta fordon',
      vehicleFavoritesSavedVehicles: 'Sparade fordon',
      vehicleFavoritesNoSavedVehicles: 'Inga sparade fordon',
      impersonatingSignedInAs: 'Inloggad som',
      impersonatingSignOut: 'Logga ut som kund',
      impersonatingAnonymousCustomer: 'anonym kund',
      superuserSearchCustomerHeader: 'Sök efter kund',
      superuserCustomerSearchLabel: 'Kundnummer',
      superuserCustomerSearchPlaceholder: 'Kundnummer',
      superuserCustomerSearchButtonLabel: 'Sök',
      superuserSearchDoSearchPhrase: 'Gör en sökning',
      superuserSearchNoHits: 'Inga sökträffar',
      superuserSearchCustomerNumber: 'Kundnr',
      superuserSearchCustomerName: 'Namn',
      superuserSearchCustomerEmail: 'E-post',
      superuserSearchPhoneNumber: 'Mobilnummer',
      superuserSearchMarket: 'Marknad',
      superuserSearchCustomerAddress: 'Address',
      superuserSearchSignInAsUserButtonLabel: 'Logga in som kund',
      superuserSearchAnonymousButtonLabel: 'Logga in som anonym kund',
      superuserSearchEditUserButtonLabel: 'Ändra kund',
      superuserChangeCustomerHeader: 'Ändra kunddata',
      superuserCustomerDataTabLabel: 'Kunddata',
      superuserCustomerEditTitle: 'Kund:',
      superuserCustomerNumberLabel: 'Kundnummer',
      superuserCustomerNumberPlaceholder: 'Ange ett kundnummer',
      superuserCustomerNameLabel: 'Namn',
      superuserCustomerNamePlaceholder: 'Ange ett namn',
      superuserCustomerCompanyNameLabel: 'Företagsnamn',
      superuserCustomerCompanyNamePlaceholder: 'Ange ett företagsnamn',
      superuserCustomerGroupLabel: 'Kundkategori',
      superuserCustomerGroupPlaceholder: 'Ange en kundkategori',
      superuserCustomerPhonenumberLabel: 'Mobilnummer',
      superuserCustomerPhonenumberPlaceholder: 'Ange ett mobilnummer',
      superuserCustomerEmailLabel: 'E-post',
      superuserCustomerEmailPlaceHolder: 'Ange en E-post',
      superuserInvoiceAddressTitle: 'Fakturaadress',
      superuserCustomerStreetLabel: 'Gatuadress',
      superuserCustomerStreetPlaceHolder: 'Ange en gatuadress',
      superuserCustomerPostalCodeLabel: 'Postnummer',
      superuserCustomerPostalCodePlaceHolder: 'Ange ett postnummer',
      superuserCustomerCityLabel: 'Ort',
      superuserCustomerCityPlaceHolder: 'Ort',
      superuserCustomerCountryLabel: 'Land',
      superuserCustomerCountryPlaceholder: 'Välj ett land',
      superuserCustomerVatnumberLabel: 'Momsregistreringsnummer',
      superuserCustomerVatnumberPlaceHolder: 'Ange ett momsregistreringsnummer',
      superuserCustomerInvoiceLabel: 'Faktura',
      superuserCustomerRequireInvoiceRefOrderNoLabel:
        'Obligatorisk faktura referens',
      superuserCustomerPdfInvoiceLabel: 'PDF faktura',
      superuserCustomerPdfInvoiceEmailLabel: 'PDF faktura e-post',
      superuserCustomerPdfInvoiceEmailPlaceholder: 'Ange en e-post',
      superuserCustomerSpecificDeliveryMethodsLabel: 'Specifik leveransmetod',
      superuserCustomerSpecificDeliveryMethodsPlaceholder:
        'Ange en leveransmetod',
      superuserCustomerEodLabel: 'EOD',
      superuserCustomerEodPlaceholder: 'Ange en EOD',
      superuserCustomerHasCustomerPricesLabel: 'Kundpriser',
      superuserCustomerIsSynedLabel: 'Är synkad',
      superuserCustomerLastModifiedLabel: 'Senast uppdaterad',
      superuserSaveAndCloseButtonLabel: 'Spara och stäng',
      superuserSaveButtonLabel: 'Spara',
      superuserCancelButtonLabel: 'Avbryt',
      superuserContinueButtonLabel: 'Fortsätt',
      superuserFormHasUnsavedDataHeader: 'Ändringar ej sparade',
      superuserFormHasUnsavedDataText:
        'Dina ändringar kommer gå förlorade om du fortsätter',
      superuserAccountChangesSavedNotification: 'Kontoändringar är sparade',
      superuserErrorInvalidCustomerCroup: null,
      superuserCustomerCredentialsTabLabel: 'Användaruppgifter',
      superuserCustomerCredentialsTitle: 'Kund:',
      superuserCustomerNewPasswordLabel: 'Ändra lösenord',
      superuserCustomerNewPasswordPlaceholder: 'Ange nytt lösenord',
      superuserCustomerNewPasswordRepeatLabel: 'Upprepa lösenord',
      superuserCustomerNewPasswordRepeatPlaceholder: 'Upprepa nytt lösenord',
      superuserSendResetLinkButtonLabel: 'Skicka glömt lösenordslänk',
      superuserPasswordLinkSentNotification: 'Glömt lösenord email är skickat',
      superuserPasswordChangedNotification: 'Lösenordet är ändrat',
      superUserSyncCustomerButtonText: 'Synkronisera',
      superUserSyncCustomerSuccessNotification: 'Kund har synkats',
      superUserSyncCustomerErrorNotification: 'Ett fel uppstod när kunden skulle synkas',
      superuserCustomerAgreementProviderIdPlaceholder: 'Ange ett id',
      superuserAddCustomerDealButtonLabel: 'Spara',
      superuserCustomerAgreementSelectDeliveryProvider: 'Levernatörer',
      useCampaignCodeAction: 'Använd',
      addedLabel: 'Tillagd',
      notificationSentLabel: 'Meddelande skickat',
      sentToLabel: 'Skickat till',
      productLinkLabel: 'Gå till produkt',
      sendAtLabel: 'Skickat'
    }
  }
}

const pages = {
  '/': {
    blocks: {
      8: {
        mainBody: { value: '<p>Huvudtext som &auml;r xhtml-formatterad.</p>' },
        compareProducts: { value: 'Jämför produkter' }
      },
      10: {
        arcticleNumber: { value: 'ArtNo' }
      },
      1000: {
        test: { value: 'Testing' }
      }
    }
  },
  '/inloggning': {
    blocks: {
      8: {
        loginHeader: 'Inloggning',
        signInDescription:
          'Fyll i dina inloggningsuppgifter och tryck på knappen logga in. OBS! Är du medlem i BM-klubben eller Fergusonklubben. Kontakta kundtjänst innan du handlar för att få dina villkor.',
        newCustomer: 'Ny kund',
        registerDescription:
          'Registrera dig här för att bli ny kund på Olsson i Ellös?',
        registerButton: 'Registrera dig här',
        fastCheckoutDescription:
          'Klicka här för att gå direkt till kassan som oinloggad',
        fastCheckoutButton: 'Gå till kassan',
        emailPlaceholder: 'Ange epost',
        password: 'Lösenord',
        passwordPlaceholder: 'Ange lösenord',
        signIn: 'Logga in',
        rememberMe: 'Jag vill förbli inloggad',
        forgotPassword: 'Glömt ditt lösenord eller användarnamn?'
      }
    }
  },
  '/kassa': {
    blocks: {
      8: {
        'eodFreeShippingMessageLabel': '<p><span class="promo-name"><strong>Grattis!</strong>&nbsp;Du handlar nu med&nbsp;<strong>fri frakt</strong>&nbsp;inom Sverige med ditt EOD-avtal<br /></span></p>',
        'shipmentMessageLabel': '<p>Med det valda leveranss&auml;ttet har du nu <strong>{0}</strong> kvar till <strong>fri frakt</strong> inom Sverige.</p>',
        'freeShipmentMessageLabel': '<p><strong>Grattis!</strong>&nbsp;Med valt leveranss&auml;tt har du nu <strong>fri frakt!</strong></p>',
        questionsTitle: 'Kontakta oss om du har frågor',
        questionsText: '<p>Kontakta oss via tel: <a href="tel:0700123456">0700 123 456</a><br />eller via mail p&aring;: <a href="mailto:kontakt@olssonparts.com">kontakt@olssonparts.com</a></p>',
        shippingAgreementExists: 'Leveransavtal finns',
        useShippingAgreement: 'Använd leveransavtal',
        shipmentAgreementNumber: 'Leveransavtalsnummer'
      }
    }
  },
  '/snabborder': {
    blocks: {
      8: {
        fastOrderHeader: 'Snabborder',
        quickOrderHeader: 'Artiklar',
        quickOrderDescription: 'Sök o lägg till artiklar',
        quickOrderTableHeaderArticle: 'Artikelnamn',
        quickOrderTableHeaderStockStatus: 'Lagerstatus',
        quickOrderTableHeaderQuantity: 'Antal',
        quickOrderTableHeaderComment: 'Kommentar',
        quickOrderTableCommentPlaceholder: 'Skriv en kommentar',
        quickOrderTableHeaderRowSum: 'Summa (exkl. moms)',
        quickOrderTableRowSum: 'Summa (ex. moms)',
        quickOrderTableHeaderTotalSum: 'Totalt (exkl. moms)',
        quickOrderTableTotalSum: 'Totalt (ex. moms)',
        quickOrderTableStockStatus: 'I lager',
        quickOrderUploadHeader: 'Lägg till flertal artiklar',
        quickOrderUploadText: 'Ladda upp artikelfil',
        quickOrderUploadSubText: 'Format: .csv eller .txt fil',
        quickOrderSearchPlaceholder: 'Ange namn eller artikelnummer',
        quickOrderUploadInstructions:
          'Instruktioner<br>Ladda upp en fil, ange enligt följande: artikelnummer, antal',
        quickOrderUploadInstructionsExample: 'Exempelfil.txt',
        quickOrderUploadInstructionsUrl: 'https://filmstaden.se',
        shoppingListHeader: 'Välj inköpslista',
        shoppingListChooseText: 'Välj lista',
        shoppingListCreateTextLabel: 'Skapa ett namn på din lista',
        shoppingListValidateName: 'Skriv ett namn på din lista',
        shoppingListPlaceholderName: 'Skriv ett namn på din lista',
        shoppingListSaveButtonLabel: 'Spara',
        shoppingListDeleteButtonLabel: 'Ta bort',
        shoppingListCancelButtonLabel: 'Ångra',
        shoppingListClearArticlesLink: 'Rensa alla artiklar',
        shoppingListAddToCartLabel: 'Lägg i varukorg',
        shoppingListCreateLink: 'Skapa inköpslista',
        totalSumText: 'Summa',
        shoppingListEditLink: 'Redigera inköpslista'
      }
    }
  },
  '/registrering': {
    blocks: {
      8: {
        registeringHeader: 'Registrering',
        registeringDescription:
          'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Pariatur architecto vero illum non iure obcaecati consectetur aspernatur id enim ea, omnis molestias optio, atque placeat praesentium est incidunt eligendi. Quas.',
        companyLabel: 'Företag',
        privateLabel: 'Privatperson',
        customerInformationHeader: 'Kunduppgifter',
        companyNameLabel: 'Företagsnamn',
        companyNamePlaceholder: 'Ange företagsnamn',
        privateNameLabel: 'Namn',
        privateNamePlaceholder: 'Ange för och efternamn',
        vatLabel: 'VAT',
        vATPlaceholder: 'Ange VAT',
        phoneNumberLabel: 'Telefonnummer',
        phoneNumberPlaceholder: 'Ange telefonnummer',
        addressHeader: 'Address',
        addressLine1Label: 'Gatuadress*',
        addressLine1Placeholder: 'Ange gatuadress',
        addressCoLabel: 'C/o adress',
        addressCoPlaceholder: 'Ange c/o adress',
        postalCodeLabel: 'Postnummer*',
        postalCodePlaceholder: 'Ange postnummer',
        cityLabel: 'Ort*',
        cityPlaceholder: 'Ange ort',
        countryLabel: 'Land',
        accountInformationHeader: 'Inloggningsuppgifter',
        passwordLabel: 'Lösenord',
        passwordPlaceholder: 'Ange lösenord',
        repeatPasswordLabel: 'Upprepa lösenord',
        pDFInvoiceLabel: 'PDF faktura',
        newsletterLabel: 'Newsletter',
        approveTermsLabel: 'The terms to approve',
        createAccountButtonLabel: 'Skapa konto'
      }
    },
    '/mina-adresser': {
      blocks: {
        8: {
          deliveryAddressCreateNewButton: 'Skapa ny adress',
          deliveryAddressCreate: 'Spara',
          deliveryAddressCancel: 'Avbryt',
          deliveryAddressConfirmDeleteAddress: 'Vill du radera addressen?'
        }
      }
    }
  },
  '/reservdelar': {
    vehicleFilterFractions: [
      {
        fractionId: 'Motorbeteckning',
        fractionTypes: [
          {
            groupId: 0,
            name: 'D42 (med 40 mm kolvbult)',
            icon: '',
            modelCode: 'CVLVehicleModel|GravlastareTraktorgravareVOLVOBM616B',
            modelName: 'VOLVO BM / 616B',
            description: 'Motorbeteckning: D42 (med 40 mm kolvbult)',
            items: ['BM-780365', 'MS7', '43970', '52585']
          },
          {
            groupId: 0,
            name: 'D42 (med 42 mm kolvbult)',
            icon: '',
            modelCode: 'CVLVehicleModel|GravlastareTraktorgravareVOLVOBM616B',
            modelName: 'VOLVO BM / 616B',
            description: 'Motorbeteckning: D42 (med 42 mm kolvbult)',
            items: ['BM-11030066', '93173960', 'MS8', '44437', '54234']
          },
          {
            groupId: 0,
            name: 'D45B',
            icon: '',
            modelCode: 'CVLVehicleModel|GravlastareTraktorgravareVOLVOBM616B',
            modelName: 'VOLVO BM / 616B',
            description: 'Motorbeteckning: D45B',
            items: [
              '32481',
              '39106',
              '38726',
              '41010',
              '41015',
              '40837',
              '42053',
              '43021',
              '43483',
              '45400',
              'BM-11990104',
              'BM-191894',
              'BM-2427',
              'BM-471195',
              'BM-787730',
              'BM-4780488',
              'BM-4780748',
              'BM-276130',
              'BM-942299',
              'BM-953492',
              'BM-4804308',
              'BM-9558354',
              'BM-4804681',
              'BM-9649',
              'BM-966999',
              'BM-4865200',
              'BM-421067',
              'BM-422217',
              'BM-466379',
              'BM-4663829',
              'BM-466386',
              'BM-466403',
              '93544970',
              'BM-4683058',
              'P553004',
              '160-7024',
              '47474',
              '44440',
              '49524',
              '51133',
              '54261',
              '49757',
              '54992',
              '64165'
            ]
          },
          {
            groupId: 0,
            name: 'TD42',
            icon: '',
            modelCode: 'CVLVehicleModel|GravlastareTraktorgravareVOLVOBM616B',
            modelName: 'VOLVO BM / 616B',
            description: 'Motorbeteckning: TD42',
            items: [
              '2641465',
              '36862166',
              '42483',
              '43476',
              '43483',
              '44438',
              '45371',
              '45372',
              '825374',
              '70169',
              'BM-119900884',
              'BM-11990104',
              'BM-1676432',
              'BM-2402',
              'BM-11030066',
              'BM-6638963',
              'BM-785418',
              'BM-785537',
              'BM-785557',
              'BM-785597',
              'BM-785598',
              'BM-785667',
              'BM-6839350',
              'BM-787575',
              'BM-787577',
              'BM-787578',
              'BM-4780488',
              'BM-34763',
              'BM-34764',
              'BM-417135',
              'BM-9650',
              'BM-7421374',
              'CAV-7111-429',
              'BM-42481',
              'BM-466284',
              'BM-466328',
              '93174970',
              'BM-469205',
              'MS9',
              'P554347',
              'P554403',
              '51487',
              '54264',
              '54992',
              '57523'
            ]
          }
        ],
        name: null
      },
      {
        fractionId: 'Motornummer',
        fractionTypes: [
          {
            groupId: 0,
            name: '-29765',
            icon: '',
            modelCode: 'CVLVehicleModel|GravlastareTraktorgravareVOLVOBM616B',
            modelName: 'VOLVO BM / 616B',
            description: 'Motornummer: -29765',
            items: ['BM-780365', 'MS7', '43970', '52585']
          },
          {
            groupId: 0,
            name: '29766-',
            icon: '',
            modelCode: 'CVLVehicleModel|GravlastareTraktorgravareVOLVOBM616B',
            modelName: 'VOLVO BM / 616B',
            description: 'Motornummer: 29766-',
            items: ['BM-11030066', '93173960', 'MS8', '44437', '54234']
          }
        ],
        name: null
      }
    ],
    fractionsAttentionText:
      '<strong>OBS!</strong> Produkten kräver ytterligare filterval för att kunna rekommenderas'
  },
  // '/reservdelar': {
  //   products: [{ 'id': '57992', 'url': '/se/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57992/', 'name': 'Filtersats liten', 'description': 'Innehåller oljefilter och bränslefilter.', 'information': null, 'specification': {}, 'items': [{ 'id': '57992', 'specification': [], 'stock': 90, 'url': '/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57992/57992', 'customerPrice': null, 'imageUrl': null, 'mediaAssetsUrl': [''], 'isOrderItem': false, 'sortOrder': 0 }], 'lowestPrice': null, 'imageUrl': '/globalassets/pim/44/44500_1generell.psd', 'mediaAssetsUrl': ['/globalassets/pim/44/44500_1generell.psd'], 'videoAssetUrl': null, 'section': 'Filtersats', 'newsSection': '', 'newsPriority': null, 'campaignSection': null, 'sectionType': 'info', 'contextDescription': '', 'currentVehicle': 'CVLVehicleModel|LastmaskinWILLE445', 'productBrand': null }, { 'id': '57993', 'url': '/se/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57993/', 'name': 'Filtersats stor', 'description': 'Innehåller oljefilter, bränslefilter, luftfilter yttre, luftfilter inre, hydraulfilter, hydraulfilter, hyttfilter och andningsfilter.', 'information': null, 'specification': {}, 'items': [{ 'id': '57993', 'specification': [], 'stock': 4, 'url': '/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57993/57993', 'customerPrice': null, 'imageUrl': null, 'mediaAssetsUrl': [''], 'isOrderItem': false, 'sortOrder': 0 }], 'lowestPrice': null, 'imageUrl': '/globalassets/pim/57/57993_1.psd', 'mediaAssetsUrl': ['/globalassets/pim/57/57993_1.psd'], 'videoAssetUrl': null, 'section': 'Filtersats', 'newsSection': '', 'newsPriority': null, 'campaignSection': null, 'sectionType': 'info', 'contextDescription': '', 'currentVehicle': 'CVLVehicleModel|LastmaskinWILLE445', 'productBrand': null }, { 'id': '57994', 'url': '/se/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57994/', 'name': 'Filtersats liten', 'description': 'Innehåller oljefilter och bränslefilter.', 'information': null, 'specification': {}, 'items': [{ 'id': '57994', 'specification': [], 'stock': 7, 'url': '/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57994/57994', 'customerPrice': null, 'imageUrl': null, 'mediaAssetsUrl': [''], 'isOrderItem': false, 'sortOrder': 0 }], 'lowestPrice': null, 'imageUrl': '/globalassets/pim/44/44500_1generell.psd', 'mediaAssetsUrl': ['/globalassets/pim/44/44500_1generell.psd'], 'videoAssetUrl': null, 'section': 'Filtersats', 'newsSection': '', 'newsPriority': null, 'campaignSection': null, 'sectionType': 'info', 'contextDescription': '', 'currentVehicle': 'CVLVehicleModel|LastmaskinWILLE445', 'productBrand': null }, { 'id': '57995', 'url': '/se/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57995/', 'name': 'Filtersats stor', 'description': 'Innehåller oljefilter, bränslefilter, luftfilter yttre, luftfilter inre, hydraulfilter, hydraulfilter, hyttfilter och andningsfilter.', 'information': null, 'specification': {}, 'items': [{ 'id': '57995', 'specification': [], 'stock': 4, 'url': '/sv/reservdelar/serviceartiklar/filter/filtersats/filtersats/57995/57995', 'customerPrice': null, 'imageUrl': null, 'mediaAssetsUrl': [''], 'isOrderItem': false, 'sortOrder': 0 }], 'lowestPrice': null, 'imageUrl': '/globalassets/pim/44/44503_1generell.psd', 'mediaAssetsUrl': ['/globalassets/pim/44/44503_1generell.psd'], 'videoAssetUrl': null, 'section': 'Filtersats', 'newsSection': '', 'newsPriority': null, 'campaignSection': null, 'sectionType': 'info', 'contextDescription': '', 'currentVehicle': 'CVLVehicleModel|LastmaskinWILLE445', 'productBrand': null }, { 'id': 'CH-40', 'url': '/se/sv/utrustning/tillbehor/belysning/reflexer/lgf-skylt/ch-40/', 'name': 'LGF-skylt  aluminium', 'description': 'LGF-skylt tillverkad i aluminium. För långsamtgående fordon. Passande fäste 39047.', 'information': null, 'specification': {}, 'items': [{ 'id': 'CH-40', 'specification': [], 'stock': 155, 'url': '/sv/utrustning/tillbehor/belysning/reflexer/lgf-skylt/ch-40/CH-40', 'customerPrice': null, 'imageUrl': null, 'mediaAssetsUrl': [''], 'isOrderItem': false, 'sortOrder': 0 }], 'lowestPrice': null, 'imageUrl': '/globalassets/pim/ch/ch-40_1.psd', 'mediaAssetsUrl': ['/globalassets/pim/ch/ch-40_1.psd'], 'videoAssetUrl': null, 'section': 'Övriga fordonstillbehör', 'newsSection': '', 'newsPriority': null, 'campaignSection': null, 'sectionType': 'info', 'contextDescription': '', 'currentVehicle': 'CVLVehicleModel|LastmaskinWILLE445', 'productBrand': null }]
  // },
  '/order-historik': {
    orders: [
      {
        orderNr: '2403600',
        orderStatus: '70',
        orderDate: '2020-02-12T00:00:00',
        displayOrderDate: '2020-02-12',
        orderSum: 1255.0,
        comment: null
      },
      {
        orderNr: '862795',
        orderStatus: '70',
        orderDate: '2020-02-11T00:00:00',
        displayOrderDate: '2020-02-11',
        orderSum: -792.0,
        comment: 'Avser order: 3248354, 32638743.'
      },
      {
        orderNr: '2402388',
        orderStatus: '70',
        orderDate: '2020-02-07T00:00:00',
        displayOrderDate: '2020-02-07',
        orderSum: 1046.0,
        comment: null
      },
      {
        orderNr: '2402200',
        orderStatus: '70',
        orderDate: '2020-02-06T00:00:00',
        displayOrderDate: '2020-02-06',
        orderSum: 702.0,
        comment: null
      },
      {
        orderNr: '2401821',
        orderStatus: '70',
        orderDate: '2020-02-05T00:00:00',
        displayOrderDate: '2020-02-05',
        orderSum: 2688.0,
        comment: null
      },
      {
        orderNr: '2401858',
        orderStatus: '70',
        orderDate: '2020-02-05T00:00:00',
        displayOrderDate: '2020-02-05',
        orderSum: 5194.0,
        comment: null
      },
      {
        orderNr: '862727',
        orderStatus: '70',
        orderDate: '2020-02-04T00:00:00',
        displayOrderDate: '2020-02-04',
        orderSum: -835.0,
        comment: 'Avser order: 2392056, 2399107.'
      },
      {
        orderNr: '2401365',
        orderStatus: '70',
        orderDate: '2020-02-04T00:00:00',
        displayOrderDate: '2020-02-04',
        orderSum: 2019.0,
        comment: 'Ackumulator 46417-140210 skall fyllas med 25BAR'
      },
      {
        orderNr: '3263761',
        orderStatus: '70',
        orderDate: '2020-01-31T00:00:00',
        displayOrderDate: '2020-01-31',
        orderSum: 100.0,
        comment: null
      },
      {
        orderNr: '3263762',
        orderStatus: '70',
        orderDate: '2020-01-31T00:00:00',
        displayOrderDate: '2020-01-31',
        orderSum: 949.0,
        comment: null
      },
      {
        orderNr: '3263743',
        orderStatus: '70',
        orderDate: '2020-01-30T00:00:00',
        displayOrderDate: '2020-01-30',
        orderSum: 792.0,
        comment:
          'Returnerade varor krediteras efter godkänd retur\r\n\r\nAvser order: 3248354'
      },
      {
        orderNr: '3263569',
        orderStatus: '70',
        orderDate: '2020-01-29T00:00:00',
        displayOrderDate: '2020-01-29',
        orderSum: 4018.0,
        comment: null
      },
      {
        orderNr: '2399107',
        orderStatus: '70',
        orderDate: '2020-01-27T00:00:00',
        displayOrderDate: '2020-01-27',
        orderSum: 656.0,
        comment: null
      },
      {
        orderNr: '2398469',
        orderStatus: '70',
        orderDate: '2020-01-24T00:00:00',
        displayOrderDate: '2020-01-24',
        orderSum: 2854.0,
        comment: null
      },
      {
        orderNr: '2397215',
        orderStatus: '20',
        orderDate: '2020-01-20T00:00:00',
        displayOrderDate: '2020-01-20',
        orderSum: 981.0,
        comment: null
      },
      {
        orderNr: '2396440',
        orderStatus: '70',
        orderDate: '2020-01-16T00:00:00',
        displayOrderDate: '2020-01-16',
        orderSum: 744.0,
        comment: null
      },
      {
        orderNr: '2396506',
        orderStatus: '70',
        orderDate: '2020-01-16T00:00:00',
        displayOrderDate: '2020-01-16',
        orderSum: 2016.0,
        comment: null
      },
      {
        orderNr: '2396140',
        orderStatus: '70',
        orderDate: '2020-01-15T00:00:00',
        displayOrderDate: '2020-01-15',
        orderSum: 9896.0,
        comment: null
      },
      {
        orderNr: '2395471',
        orderStatus: '70',
        orderDate: '2020-01-13T00:00:00',
        displayOrderDate: '2020-01-13',
        orderSum: 2411.0,
        comment: null
      },
      {
        orderNr: '2395047',
        orderStatus: '70',
        orderDate: '2020-01-10T00:00:00',
        displayOrderDate: '2020-01-10',
        orderSum: 774.0,
        comment: null
      },
      {
        orderNr: '2394785',
        orderStatus: '70',
        orderDate: '2020-01-09T00:00:00',
        displayOrderDate: '2020-01-09',
        orderSum: 3483.0,
        comment: null
      },
      {
        orderNr: '2394338',
        orderStatus: '70',
        orderDate: '2020-01-08T00:00:00',
        displayOrderDate: '2020-01-08',
        orderSum: 5549.0,
        comment: null
      },
      {
        orderNr: '3261631',
        orderStatus: '70',
        orderDate: '2020-01-07T00:00:00',
        displayOrderDate: '2020-01-07',
        orderSum: 112.0,
        comment: null
      },
      {
        orderNr: '2393197',
        orderStatus: '70',
        orderDate: '2020-01-03T00:00:00',
        displayOrderDate: '2020-01-03',
        orderSum: 6753.0,
        comment: null
      },
      {
        orderNr: '2392951',
        orderStatus: '70',
        orderDate: '2020-01-02T00:00:00',
        displayOrderDate: '2020-01-02',
        orderSum: 15265.0,
        comment: null
      }
    ]
  },
  '/order-bekräftelse': {
    orders: [
      {
        orderNr: '2403600',
        orderStatus: '70',
        orderDate: '2020-02-12T00:00:00',
        displayOrderDate: '2020-02-12',
        orderSum: 1255.0,
        comment: null
      },
      {
        orderNr: '862795',
        orderStatus: '70',
        orderDate: '2020-02-11T00:00:00',
        displayOrderDate: '2020-02-11',
        orderSum: -792.0,
        comment: 'Avser order: 3248354, 32638743.'
      },
      {
        orderNr: '2402388',
        orderStatus: '70',
        orderDate: '2020-02-07T00:00:00',
        displayOrderDate: '2020-02-07',
        orderSum: 1046.0,
        comment: null
      },
      {
        orderNr: '2402200',
        orderStatus: '70',
        orderDate: '2020-02-06T00:00:00',
        displayOrderDate: '2020-02-06',
        orderSum: 702.0,
        comment: null
      },
      {
        orderNr: '2401821',
        orderStatus: '70',
        orderDate: '2020-02-05T00:00:00',
        displayOrderDate: '2020-02-05',
        orderSum: 2688.0,
        comment: null
      },
      {
        orderNr: '2401858',
        orderStatus: '70',
        orderDate: '2020-02-05T00:00:00',
        displayOrderDate: '2020-02-05',
        orderSum: 5194.0,
        comment: null
      },
      {
        orderNr: '862727',
        orderStatus: '70',
        orderDate: '2020-02-04T00:00:00',
        displayOrderDate: '2020-02-04',
        orderSum: -835.0,
        comment: 'Avser order: 2392056, 2399107.'
      },
      {
        orderNr: '2401365',
        orderStatus: '70',
        orderDate: '2020-02-04T00:00:00',
        displayOrderDate: '2020-02-04',
        orderSum: 2019.0,
        comment: 'Ackumulator 46417-140210 skall fyllas med 25BAR'
      },
      {
        orderNr: '3263761',
        orderStatus: '70',
        orderDate: '2020-01-31T00:00:00',
        displayOrderDate: '2020-01-31',
        orderSum: 100.0,
        comment: null
      },
      {
        orderNr: '3263762',
        orderStatus: '70',
        orderDate: '2020-01-31T00:00:00',
        displayOrderDate: '2020-01-31',
        orderSum: 949.0,
        comment: null
      },
      {
        orderNr: '3263743',
        orderStatus: '70',
        orderDate: '2020-01-30T00:00:00',
        displayOrderDate: '2020-01-30',
        orderSum: 792.0,
        comment:
          'Returnerade varor krediteras efter godkänd retur\r\n\r\nAvser order: 3248354'
      },
      {
        orderNr: '3263569',
        orderStatus: '70',
        orderDate: '2020-01-29T00:00:00',
        displayOrderDate: '2020-01-29',
        orderSum: 4018.0,
        comment: null
      },
      {
        orderNr: '2399107',
        orderStatus: '70',
        orderDate: '2020-01-27T00:00:00',
        displayOrderDate: '2020-01-27',
        orderSum: 656.0,
        comment: null
      },
      {
        orderNr: '2398469',
        orderStatus: '70',
        orderDate: '2020-01-24T00:00:00',
        displayOrderDate: '2020-01-24',
        orderSum: 2854.0,
        comment: null
      },
      {
        orderNr: '2397215',
        orderStatus: '20',
        orderDate: '2020-01-20T00:00:00',
        displayOrderDate: '2020-01-20',
        orderSum: 981.0,
        comment: null
      },
      {
        orderNr: '2396440',
        orderStatus: '70',
        orderDate: '2020-01-16T00:00:00',
        displayOrderDate: '2020-01-16',
        orderSum: 744.0,
        comment: null
      },
      {
        orderNr: '2396506',
        orderStatus: '70',
        orderDate: '2020-01-16T00:00:00',
        displayOrderDate: '2020-01-16',
        orderSum: 2016.0,
        comment: null
      },
      {
        orderNr: '2396140',
        orderStatus: '70',
        orderDate: '2020-01-15T00:00:00',
        displayOrderDate: '2020-01-15',
        orderSum: 9896.0,
        comment: null
      },
      {
        orderNr: '2395471',
        orderStatus: '70',
        orderDate: '2020-01-13T00:00:00',
        displayOrderDate: '2020-01-13',
        orderSum: 2411.0,
        comment: null
      },
      {
        orderNr: '2395047',
        orderStatus: '70',
        orderDate: '2020-01-10T00:00:00',
        displayOrderDate: '2020-01-10',
        orderSum: 774.0,
        comment: null
      },
      {
        orderNr: '2394785',
        orderStatus: '70',
        orderDate: '2020-01-09T00:00:00',
        displayOrderDate: '2020-01-09',
        orderSum: 3483.0,
        comment: null
      },
      {
        orderNr: '2394338',
        orderStatus: '70',
        orderDate: '2020-01-08T00:00:00',
        displayOrderDate: '2020-01-08',
        orderSum: 5549.0,
        comment: null
      },
      {
        orderNr: '3261631',
        orderStatus: '70',
        orderDate: '2020-01-07T00:00:00',
        displayOrderDate: '2020-01-07',
        orderSum: 112.0,
        comment: null
      },
      {
        orderNr: '2393197',
        orderStatus: '70',
        orderDate: '2020-01-03T00:00:00',
        displayOrderDate: '2020-01-03',
        orderSum: 6753.0,
        comment: null
      },
      {
        orderNr: '2392951',
        orderStatus: '70',
        orderDate: '2020-01-02T00:00:00',
        displayOrderDate: '2020-01-02',
        orderSum: 15265.0,
        comment: null
      }
    ],
    orderDetailsDescription:
      'Vi plockar och packar och skickar den så snart som möjligt. Har du några frågor? Kontakta oss på kundservice@olssonparts.com'
  },
  '/superuser': {
    blocks: {
      8: {
        superuserChangeCustomerHeader: 'Ändra kunddata',
        superuserSearchCustomerHeader: 'Sök efter kund',
        superuserCustomerDataTabLabel: 'Kunddata',
        superuserCustomerCredentialsTitle: 'Kund:',
        superuserSearchCustomerNumber: 'Kundnummer',
        superuserSearchCustomerName: 'Namn',
        superuserSearchCustomerEmail: 'E-post',
        superuserSearchPhoneNumber: 'Mobilnummer',
        superuserSearchMarket: 'Marknad',
        superuserSearchSignInAsUserButtonLabel: 'Logga in som kund',
        superuserSearchEditUserButtonLabel: 'Ändra kund',
        superuserSearchDoSearchPhrase: 'Gör en sökning',
        superuserSearchNoHits: 'Inga sökträffar',
        superuserCustomerSearchLabel: 'Kundnummer',
        superuserCustomerSearchButtonLabel: 'Sök',
        superuserCustomerEditTitle: 'Kund:',
        superuserCustomerNumberLabel: 'Kundnummer',
        superuserCustomerNumberPlaceholder: 'Kundnummer',
        superuserCustomerNameLabel: 'Namn',
        superuserCustomerNamePlaceholder: 'Namn',
        superuserCustomerCompanyNameLabel: 'Företagsnamn',
        superuserCustomerCompanyNamePlaceholder: 'Företagsnamn',
        superuserCustomerGroupLabel: 'Kundkategori',
        superuserCustomerGroupPlaceholder: 'Kundkategori',
        superuserCustomerPhonenumberLabel: 'Mobilnummer',
        superuserCustomerPhonenumberPlaceholder: 'Mobilnummer',
        superuserCustomerUserIdLabel: 'E-post',
        superuserCustomerUserIdPlaceHolder: 'E-post',
        superuserInvoiceAddressTitle: 'Fakturaadress',
        superuserCustomerStreetLabel: 'Gatuadress',
        superuserCustomerStreetPlaceHolder: 'Gatuadress',
        superuserCustomerStreetTwoLabel: 'C/O',
        superuserCustomerStreetTwoPlaceholder: 'C/O',
        superuserCustomerPostalCodeLabel: 'Postnummer',
        superuserCustomerPostalCodePlaceHolder: 'Postnummer',
        superuserCustomerCityLabel: 'Ort',
        superuserCustomerCityPlaceHolder: 'Ort',
        superuserCustomerCountryLabel: 'Land',
        superuserCustomerCountryPlaceHolder: 'Land',
        superuserCustomerInvoiceLabel: 'Faktura',
        superuserCustomerPdfInvoiceLabel: 'PDF Faktura',
        superuserCustomerRequireInvoiceRefOrderNoLabel:
          'Obligatorisk faktura referens',
        superuserCustomerCredentialsTabLabel: 'Användaruppgifter',
        superuserCustomerNewPasswordLabel: 'Ändra lösenord',
        superuserCustomerNewPasswordPlaceholder: 'Ange nytt lösenord',
        superuserCustomerNewPasswordRepeatLabel: 'Upprepa lösenord',
        superuserCustomerNewPasswordRepeatPlaceholder: 'Upprepa nytt lösenord',
        superuserSendResetLinkButtonLabel: 'Skicka glömt lösenordslänk',
        superuserCancelButtonLabel: 'Avbryt',
        superuserSaveAndCloseButtonLabel: 'Spara och stäng',
        superuserSaveButtonLabel: 'Spara',
        superuserContinueButtonLabel: 'Fortsätt',
        superuserFormHasUnsavedDataHeader: 'Ändringar ej sparade',
        superuserFormHasUnsavedDataText: 'Dina ändringar kommer gå förlorade om du fortsätter',
        superuserCustomerAgreementTabLabel: 'Kundens avtal',
        superuserCustomerCoLabel: 'C/o adress',
        superuserCustomerCoPlaceHolder: 'Ange en c/o adress'
      }
    }
  },
  '/sök': {
    enableSearchSpecificationFacets: true
  }
}

function getCurrentPageData(path) {
  const pageData = pages[path]
  return _.merge({ matched: !!pageData }, pageData, common)
}

module.exports = { getCurrentPageData, common }
